import { render, staticRenderFns } from "./GraphPeriodicStat.vue?vue&type=template&id=04b0d89e&scoped=true&"
import script from "./GraphPeriodicStat.vue?vue&type=script&lang=js&"
export * from "./GraphPeriodicStat.vue?vue&type=script&lang=js&"
import style0 from "./GraphPeriodicStat.vue?vue&type=style&index=0&id=04b0d89e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b0d89e",
  null
  
)

export default component.exports